export default "__VITE_ASSET__1bfb14a1__"